import React, { useState } from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import BildHeader from "../../images/services/sehtest/header.jpg"
import BildLinks from "../../images/services/visualtraining/abutz-20241003-DSC_9876-2.jpg"
import SubNavigation from "../../components/SubNavServices"
import Termin from "../../components/Termin"

const Visualtraining: React.FC = () => {
  const siteTitle = "Visualtraining – Dienstleistungen"
  const [isSubMenuOpen, setSubMenuOpen] = useState(false)

  return (
    <Layout title={siteTitle}>
      <SEO title={siteTitle} />
      <section className="wrapper">
        <div className="headerImage">
          <img src={BildHeader} />
        </div>
      </section>
      <Termin />
      <SubNavigation
        isSubMenuOpen={isSubMenuOpen}
        setSubMenuOpen={setSubMenuOpen}
        activeMenuText="Visualtraining"
      />
      <section className="wrapper greyColor content">
        <h1>Visualtraining & optometrische Sehanalyse</h1>
        <h2 className="contentSubtitle">SCHWARZ Optik – Seit 1992 in Heiden</h2>
        <div className="contentColumns">
          <div className="contentColumn">
            <div className="imageCollection">
              <div className="imageRow">
                <img src={BildLinks} />
              </div>
            </div>
            <h2>Visualtraining setzt dort an, wo das Sehen ins Stocken geraten ist.</h2>
            <p>
              Durch gezielte, individuell aufgebaute Übungen lernen Augen und Gehirn, wieder effizienter zusammenzuarbeiten. Das Training unterstützt sowohl Kinder als auch Erwachsene – sei es bei schulischen Anforderungen, Bildschirmarbeit oder allgemeiner visueller Überlastung.
            </p>
            <p>
              Unsere Optometrist:innen verfügen über eine fundierte Ausbildung, unter anderem mit zusätzlicher Weiterbildung im Bereich Funktional-Optometrie. Dieses Wissen erlaubt uns, Training und Analyse so zu gestalten, dass sie sinnvoll aufgebaut und nachvollziehbar sind. Somit für den Alltag unserer Kund:innen wirklich wirksam sind.
            </p>
            <p>Das Ziel ist nicht nur schärferes, sondern entspannteres Sehen.</p>
            <p>
              Ein visuelles System, das stabil arbeitet, entlastet Schule, Beruf und Freizeit – und macht Sehen wieder selbstverständlich.
            </p>
            
          </div>
          <div className="contentColumn">
<h2>Sehen ist nicht angeboren. Es entwickelt sich und kann gezielt trainiert werden.</h2>
            <p>
              Sehen entsteht nicht allein in den Augen, es ist ein ganzheitlicher Prozess, der sowohl den Menschen als auch seine Umwelt einbezieht. Das Zusammenspiel aus Wahrnehmung, Verarbeitung und Koordination entwickelt sich über die Jahre hinweg. Wenn an einem dieser Schritte etwas aus dem Gleichgewicht gerät, wird Sehen anstrengend. Genau dann zeigen sich typische Beschwerden wie Kopfschmerzen, rasche Ermüdung, Probleme beim Lesen und Schreiben oder Unsicherheiten bei der Orientierung.
            </p>
            <p>
              In unserer optometrischen Sehanalyse betrachten wir das visuelle System deshalb in seiner Gesamtheit. Wir prüfen nicht nur die Sehschärfe, sondern analysieren Augenbewegungen, Zusammenarbeit beider Augen, Flexibilität beim Scharfstellen und die visuelle Belastbarkeit. So erkennen wir, ob das Sehen stabil und effizient funktioniert oder ob das Gehirn zu viel kompensieren muss.
            </p>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Visualtraining
